module.exports = ".invalid-message{color:#ef4444;font-size:0.75em;font-weight:600;text-transform:none}.invalid-message *{margin-left:0.1875em}\n"